import { create } from 'zustand';
import { authAPI } from '../services/api';
import useOrgStore from './orgStore';

const useAuthStore = create((set, get) => ({
  user: JSON.parse(localStorage.getItem('user') || 'null'),
  token: localStorage.getItem('auth_token'),
  isAuthenticated: !!localStorage.getItem('auth_token'),
  isLoading: false,

  login: async (email, password) => {
    set({ isLoading: true });
    try {
      const response = await authAPI.login({ email, password });
      const { token, refresh_token, user, current_org, organizations } = response;

      // Store auth data
      localStorage.setItem('auth_token', token);
      localStorage.setItem('user', JSON.stringify(user));
      if (refresh_token) {
        localStorage.setItem('refresh_token', refresh_token);
      }

      set({ user, token, isAuthenticated: true, isLoading: false });

      // Set org data in orgStore
      const orgStore = useOrgStore.getState();
      if (organizations) {
        orgStore.setOrganizations(organizations);
      }
      if (current_org) {
        orgStore.setCurrentOrg(current_org);
      }

      return { success: true, organizations: organizations || [] };
    } catch (error) {
      set({ isLoading: false });
      return { success: false, error: error.message };
    }
  },

  logout: () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user');
    localStorage.removeItem('refresh_token');
    set({ user: null, token: null, isAuthenticated: false });

    // Clear org state
    const orgStore = useOrgStore.getState();
    orgStore.clearOrg();
  },

  updateUser: (userData) => {
    const updatedUser = { ...get().user, ...userData };
    localStorage.setItem('user', JSON.stringify(updatedUser));
    set({ user: updatedUser });
  },
}));

export default useAuthStore;
